import React from "react";
import useAuth from "../hooks/useAuth";
import { Redirect, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { addRedirectUrlToPath, getRedirectUrl, setRedirectUrl } from "src/utils/pathUtils";

const AuthGuard = ({ children }) => {
  const { isAuthenticated, user, company } = useAuth();
  const location = useLocation();
  
  if (!isAuthenticated) {
    console.log(location);
    setRedirectUrl(location.pathname + location.search);
    return <Redirect to={addRedirectUrlToPath("/login", getRedirectUrl())} />;
  }

  if(user.isTempPassword){
    return <Redirect to={addRedirectUrlToPath("/app/changePassword", getRedirectUrl())} />;
  }

  if(user.twoFactorEnabled && !user.isCodeVerified){
    return <Redirect to={addRedirectUrlToPath("/app/twoFactorVerification", getRedirectUrl())} />;
  }

  if((user.emailAddress == "ankur.gupta@highlands.in"
    || user.emailAddress == "akaliappan@disputesoft.com"
    || user.emailAddress.toLowerCase().includes("disputesoft")
    || company?.companyName.toLowerCase().includes("testing account - ankit jain"))
    && (location.pathname.toLowerCase().includes("/app/products/all")
    || location.pathname.toLowerCase().includes("admin")))
    {
      return <Redirect to={addRedirectUrlToPath("/app/home", getRedirectUrl())} />;
    }

  if((company?.companyName.toLowerCase().includes("agouti environment")
  || company?.companyName.toLowerCase().includes("yenon-research & design ltd.")
  || company?.companyName.toLowerCase().includes("lygm environmental projects")
  || company?.companyName.toLowerCase().includes("hydrocycle ltd - environment & water engineering")
  || company?.companyName.toLowerCase().includes("hydromodul ltd")
  || company?.companyName.toLowerCase().includes("hasson-yerushalmi engineers")
  || company?.companyName.toLowerCase().includes("lavi-natif elgavish (2014 ltd)")
  || company?.companyName.toLowerCase().includes("afik environmental engineering & hydrology"))
    && (location.pathname.toLowerCase().includes("/app/products/all"))){
      return <Redirect to={addRedirectUrlToPath("/app/home", getRedirectUrl())} />;
    }

  let redirectUrl = getRedirectUrl();
  if(redirectUrl
    && redirectUrl !== "")
  {
    setRedirectUrl("");
    return <Redirect to={redirectUrl} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
